import Component from '../../shared/component';
import MentorshipRatingForm from './mentorship-rating-form';

const RESET_DELAY = 100;

export default class UserQuickInfos extends Component {
  constructor(element) {
    super(...arguments);

    this.$element = $(element);
    this.$content = this.$element.find('.userQuickInfos-data');
    this.$loading = this.$element.find('.userQuickInfos-loading');
    this.$error = this.$element.find('.userQuickInfos-error');

    this.bindEvents();
  }

  bindEvents() {
    this.handleShow = this.handleShow.bind(this);
    this.handleHide = this.handleHide.bind(this);

    this.$element.on('show.bs.modal.userQuickInfos', this.handleShow);
    this.$element.on('hide.bs.modal.userQuickInfos', this.handleHide);
  }

  unbindEvents() {
    this.$element.off('show.bs.modal.userQuickInfos', this.handleShow);
    this.$element.off('hide.bs.modal.userQuickInfos', this.handleHide);

    // Reset modal content and hide it before turbolinks cache snapshot.
    if (!this.$element.hasClass('in')) {
      this.resetContent();
    }
    this.$element.removeClass('fade').modal('hide');

    if (this.mentorRatingForm) {
      this.mentorRatingForm.unbindEvents();
    }
  }

  handleShow(event) {
    const $target = $(event.relatedTarget);

    $.get($target.data('path'))
      .done((data) => this.handleDataSuccess(data))
      .fail(() => this.handleDataError());
  }

  handleHide() {
    setTimeout(() => {
      if (!this.$element.hasClass('in')) {
        this.resetContent();
      }
    }, RESET_DELAY);
  }

  resetContent() {
    this.$content.html('');
    this.$error.hide();
    this.$loading.show();
  }

  handleDataSuccess(data) {
    this.$loading.hide();
    this.$content.html(data);

    this.mentorRatingForm = new MentorshipRatingForm(this.$content);
  }

  handleDataError() {
    this.$loading.hide();
    this.$error.show();
  }
}
